const MAX_DIMENSION = 1920;
const JPEG_QUALITY = 0.82;
const COMPRESS_THRESHOLD_BYTES = 500 * 1024; // solo comprimir si > 500 KB

const IMAGE_TYPES = new Set(['image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'image/tiff']);

export function isCompressibleImage(file: File): boolean {
  return IMAGE_TYPES.has(file.type) && file.size > COMPRESS_THRESHOLD_BYTES;
}

export async function compressImageFile(file: File): Promise<File> {
  if (!isCompressibleImage(file)) return file;

  return new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);

      let { width, height } = img;
      if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
        if (width > height) {
          height = Math.round((height * MAX_DIMENSION) / width);
          width = MAX_DIMENSION;
        } else {
          width = Math.round((width * MAX_DIMENSION) / height);
          height = MAX_DIMENSION;
        }
      }

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      if (!ctx) { resolve(file); return; }

      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        (blob) => {
          if (!blob || blob.size >= file.size) { resolve(file); return; }
          const outputName = file.name.replace(/\.[^.]+$/, '.jpg');
          resolve(new File([blob], outputName, { type: 'image/jpeg', lastModified: Date.now() }));
        },
        'image/jpeg',
        JPEG_QUALITY
      );
    };

    img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
    img.src = url;
  });
}
